import { render, staticRenderFns } from "./TaskGroupWorkRecord.vue?vue&type=template&id=f2d11072&scoped=true&"
import script from "./TaskGroupWorkRecord.vue?vue&type=script&lang=js&"
export * from "./TaskGroupWorkRecord.vue?vue&type=script&lang=js&"
import style0 from "./TaskGroupWorkRecord.vue?vue&type=style&index=0&id=f2d11072&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d11072",
  null
  
)

export default component.exports